import { render, staticRenderFns } from "./BienBanHCHT.vue?vue&type=template&id=0923571b&scoped=true"
import script from "./BienBanHCHT.vue?vue&type=script&lang=js"
export * from "./BienBanHCHT.vue?vue&type=script&lang=js"
import style0 from "./BienBanHCHT.vue?vue&type=style&index=0&id=0923571b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0923571b",
  null
  
)

export default component.exports